export const claimTypeEnum = {
    Accident: "accident",
    Disease: "disease"
}
Object.freeze(claimTypeEnum);

export const formTypeEnum = {
    unemploymentForm: "formunemployment",
    workIncapacityForm: "formworkincapacity",
    hospitalisedForm: "formhospitalised",
    step1: "step1personalinfo",
}
Object.freeze(formTypeEnum);